import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Table, TableBody, TableRow, Tooltip, Typography } from '@mui/material';
import type { ControlViolations, BackupStatus } from '@repo/api-gw-sdk';
import type React from 'react';
import { BorderlessTableCell } from '@/components/table/components';
import { BackupStatuses, ControlsSeverity } from '@/data/inventory/data';
import { BackupStatusIcon } from '../backupStatus/backupStatusIcon';
export const ControlIndicator = t0 => {
  const $ = _c(2);
  const {
    backgroundColor
  } = t0;
  let t1;
  if ($[0] !== backgroundColor) {
    t1 = <Box component="span" className="rounded-full w-[8px] h-[8px] m-[8px] inline-block" sx={{
      backgroundColor,
      flexShrink: 0,
      minWidth: "8px",
      minHeight: "8px"
    }} />;
    $[0] = backgroundColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const controlKeysPriorities: (keyof ControlViolations)[] = ['high', 'medium', 'low', 'muted'];

// The severity breakdown any axis that reports on violations can hang off its icon: the status
// name, then one row per non-zero severity. Rendered as the Tooltip's title rather than around it,
// so a resource with no violations still gets the plain name instead of losing the tooltip.
const ControlViolationsBreakdown = t0 => {
  const $ = _c(10);
  const {
    title,
    controlViolations
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      color: "var(--mui-palette-Tooltip-text)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Typography className="mb-[8px]" sx={t1}>{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== controlViolations) {
    t3 = controlKeysPriorities.map(priority => {
      const amount = controlViolations[priority];
      return !!amount && <TableRow key={priority} className="mt-[4px] py-[2px]"><BorderlessTableCell><ControlIndicator backgroundColor={ControlsSeverity[priority].color} /></BorderlessTableCell><BorderlessTableCell><Typography className="ml-[8px]" sx={{
            color: "var(--mui-palette-Tooltip-text)"
          }}>{amount}</Typography></BorderlessTableCell><BorderlessTableCell><Typography className="ml-[8px]" sx={{
            color: "var(--mui-palette-Tooltip-text)"
          }}>{ControlsSeverity[priority].title}</Typography></BorderlessTableCell></TableRow>;
    });
    $[3] = controlViolations;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Table><TableBody>{t3}</TableBody></Table>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Stack>{t2}{t4}</Stack>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const ControlViolationsTooltip = t0 => {
  const $ = _c(11);
  const {
    title,
    controlViolations,
    children
  } = t0;
  const t1 = !controlViolations;
  let t2;
  if ($[0] !== controlViolations || $[1] !== title) {
    t2 = controlViolations ? <ControlViolationsBreakdown title={title} controlViolations={controlViolations} /> : title;
    $[0] = controlViolations;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = controlViolations ? "170px" : undefined;
  const t4 = controlViolations ? "16px" : undefined;
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = {
      tooltip: {
        sx: {
          width: t3,
          padding: t4
        }
      }
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t1 || $[8] !== t2 || $[9] !== t5) {
    t6 = <Tooltip disableInteractive={t1} title={t2} className="ml-[8px]" slotProps={t5}>{children}</Tooltip>;
    $[6] = children;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export const ControlsColumnIndicators = t0 => {
  const $ = _c(6);
  const {
    controlViolations,
    backupStatus
  } = t0;
  const data = BackupStatuses[backupStatus];
  if (!data) {
    return null;
  }
  let t1;
  if ($[0] !== backupStatus) {
    t1 = <BackupStatusIcon backupStatus={backupStatus} />;
    $[0] = backupStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== controlViolations || $[3] !== data.title || $[4] !== t1) {
    t2 = <ControlViolationsTooltip title={data.title} controlViolations={controlViolations}>{t1}</ControlViolationsTooltip>;
    $[2] = controlViolations;
    $[3] = data.title;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};